import type { HoroscopeTypeSlug, ZodiacSign } from 'types/objectTypes';

export const LINK_TYPE = 'Link';
export const NAV_ITEM_TYPE = 'NavItem';
export const TEXT_TYPE = 'Text';
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const USER = 'user';
export const NC_OFFER_SLIDER_INTERVAL_DELAY = 7000;
export const FAVORITE_PSYCHIC_HINT_HIDING = 7000;
export const SCROLL_EVENT = 'scroll';
export const MOUSEDOWN_EVENT = 'mousedown';
export const RESIZE = 'resize';
export const SEARCH_BOX_DEBOUNCE_DELAY = 200;
export const ONE_HUNDRED_DAYS = 100 * 24 * 3600;
export const MINUTE_IN_SECONDS = 60;
export const ONE_DAY_IN_MS = 1000 * 60 * MINUTE_IN_SECONDS * 24;
export const SESSION_COOKIE_NAME = 'auth';
export const SET_COOKIE_HEADER = 'set-cookie';
export const LABEL_COOKIE_NAME = 'label';
export const CALLBACK_URL = 'next-callbackUrl';
export const GDPR_COOKIE = 'GDPRCookie';
export const USER_AGENT = 'user-agent';
export const WEBP_TYPE = 'image/webp';
export const SVG_TYPE = 'image/svg';
export const PNG_TYPE = 'image/png';
export const SVG_XML_TYPE = 'image/svg+xml';
export const WEBP_FORMAT = 'webp';
export const SOURCE_NODE_NAME = 'SOURCE';
export const IMG_NODE_NAME = 'IMG';
export const MIN_ALLOWED_AGE = 18;
export const DEFAULT_SELECT_OPTION = 'default';
export const HEAD_SCRIPTS = 'headScripts';
export const CLOSING_SCRIPTS = 'closingScripts';
export const DATA_NAVIGATION_ATTRIBUTE_NAME = process.env.NEXT_PUBLIC_DATA_NAVIGATION_GA || 'data-navigation';
export const ROUTE_CHANGE_START = 'routeChangeStart';
export const ROUTE_CHANGE_COMPLETE = 'routeChangeComplete';
export const EXTERNAL_WEBP_IMAGE = 'external';
export const SLASH_SYMBOL_LENGTH = 1;
export const IMAGE_SIZE_RATIO = 0.5;
export const TEXTAREA_MAX_LENGTH = 5000;
export const COLLAPSE = 'collapse';
export const EXPAND = 'expand';
export const DEFAULT_SRC = '#';
export const MAX_CONTENTFUL_IMAGE_SIDE_SIZE = 4000;
export const YOUTUBE = 'youtube';
export const BUTTON = 'button';
export const IS_CLIENT_SIDE = Boolean(typeof window !== 'undefined');
export const AWS_BUCKET_NAME = 'cp-cms';
export const NEW_LINE_SIGN = '   ';
export const USA_COUNTRY_NAME = 'USA';

/* cookie */
export const ASK_ACCOUNT_INFO = 'askAccountInfo';
export const USER_TIME_ZONE = 'userTimeZone';
export const ENHANCED_PRICING = 'enhancedpricing';
export const CHAT_AGENT_PERSISTANCE_COOKIE = 'chatAgentPersistance';
export const CHAT_SESSION_COOKIE = 'chatSessionActive';
export const MAS_PHONE_NUMBER = 'MASPhoneNumber';
export const NC_OFFER = 'ncoffer';
export const IS_FIXED_BANNER_SEEN = 'isFixedBannerSeen';
export const OAUTH_REDIRECT_URL = 'oAuthRedirectUrl';
export const TEMP_REFERRER_COOKIE = '_referrer';
export const SORT_ID_COOKIE = 'PsychicCustomSortId';
export const CTA_TYPE = 'CTAType';
export const PSYCHIC_TALK_COOKIE_BIO = 'PsychicTalkCookieBio';
export const PSYCHIC_LIST_OPTION_COOKIE = 'PsychicListOption';
export const CURRENT_VIEW_COOKIE = 'CurrentView';
export const OFFER_CHECKOUT = 'offerCheckout';
export const CLIENT_WIDTH = '__clientWidth__';
export const RELOAD_MODULES_ATTEMPTS = 'reload-modules-attempts';
export const VIEWER_DEVICE = 'viewer-device';
export const LAST_INTERACTED_PSYCHIC = 'lastInteractedPsychic';
export const PAYPAL_DATA_COOKIE = 'payPalData';

/* tags */
export const BR_TAG = '<br>';
export const LINK_TAG_NAME = 'a';

/* Horoscopes */
export const HOROSCOPE_PAGE_MOBILE_ICON_SIDE_SIZE = 65;
export const HOROSCOPE_PAGE_DESKTOP_ICON_SIDE_SIZE = 54;

/* Extensions */
export const CSS_EXTENSION = '.css';
export const JSON_EXTENSION = '.json';

/* Hardcoded slugs */
export const CONTACT_US_SLUG = 'contact';
export const HOMEPAGE_SLUG = 'homepage';
export const PSYCHICS_READINGS_NEW_SLUG = 'psychic-readings-new';
export const EC_HOMEPAGE_SLUG = 'echomepage';
export const ABOUT_SLUG = 'about';
export const HELP_TELEPHONE_SLUG = 'help-telephone';
export const LIVE_CHAT_SLUG = 'live-chat';
export const PAYMENT_SETTINGS = 'payment-settings';
export const MY_INBOX = 'my-inbox';
export const KARMA_NAV_ITEM = 'karma';
export const NON_KARMA_NAV_ITEM = 'join-karma';
export const BIO_SLUG = 'psychic-bio';
export const READING_SLUG = 'psychic-readings-new';
export const DODGE_THE_DUBIOUS = 'DodgetheDubious';
export const SLIM_HP_PERCENT = 'slim-hp-percent';
export const PERCENT_HP_SLIM = 'percent-hp-slim';
export const TRIM_HP_CLARITY = 'trim-hp-clarity';
export const MY_FAVORITE_PSYCHICS = 'my-favorite-psychics';
export const SLIM_HOMEPAGE_SLUG = 'slim-homepage';
export const HOMEPAGE_MAR25_SLUG = 'home-mar25';
export const HOW_IT_WORKS = 'how-it-works';

/* Agent Chat */
export const AGENT_CHAT_IFRAME_ID = 'ctm-frame-0';

/* Array constants */
export const HOROSCOPES_TYPES: HoroscopeTypeSlug = ['daily', 'weekly-love', 'monthly', 'yearly', 'weekend', 'monthly-money'];
export const ZODIAC_SIGNS: Array<ZodiacSign> = ['aries', 'taurus', 'gemini', 'cancer', 'leo', 'virgo', 'libra', 'scorpio', 'sagittarius', 'capricorn', 'aquarius', 'pisces'];

/* Dynamic routs */
export const HOROSCOPE_SIGN_NAME = 'signName';

/* Exponea */
export const EXPONEA_RECOMMENDATION_SIZE_MULTIPLIER = 10;

/* Url */
export const SIGN_IN_URL = `${process.env.NEXT_PUBLIC_BASE_SERVER_URL}/sign-in`;
export const SIGN_UP_URL = `${process.env.NEXT_PUBLIC_BASE_SERVER_URL}/ask-question-signup`;
export const SIGN_UP_SECOND_STEP_URL = `${process.env.NEXT_PUBLIC_BASE_SERVER_URL}/ask-question-checkout`;
export const NC_FUNNEL_SIGN_UP_URL = `${process.env.NEXT_PUBLIC_BASE_SERVER_URL}/ncsignup`;

export const LOWERCASE_SORT_ID_KEY = 'sortid';
